<template>
  <div>
    <modal
      name="team-update"
      :adaptive="true"
      :minHeight="520"
      :maxHeight="auto"
      :scrollable="true"
    >
      <div class="text-center mt-4">
        <h6 class="text-gray-600 text-xl font-bold">Team - {{ name }}</h6>
      </div>
      <div style="margin: 20px">
        <FormulateForm @submit="updateTeam">
          <div class="flex flex-wrap">
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="name"
                label="Name"
                validation="optional|min:1"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
                :value="this.name"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="name"
                label="Owner"
                validation="optional"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
                disabled
                :value="this.owner"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="description"
                label="Description"
                validation="optional"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
                :value="this.description"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="image"
                name="image"
                v-on:change="onChangeFileUpload($event)"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                label="Select an image to upload"
                help="Select a png or jpg to upload."
                validation="mime:image/jpeg,image/png"
              />
            </div>
            <div class="w-full xl:w-12/12 xl:mb-0 px-2 mt-5">
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Update"
              />
            </div>
          </div>
        </FormulateForm>
      </div>
    </modal>
  </div>
</template>
<script>
/* 
  Class: ModalTeamUpdate
  Description: This class representing a team update modal.
*/

/* Imports */
import TeamService from "@/services/team.service";
/* /Imports/ */

export default {
  /* 
    Define data with custom teams state values. 
  */
  data() {
    return {
      image: null,
    };
  },

  /* 
    Define props from which we got team data. 
  */
  props: {
    id: null,
    name: null,
    owner: null,
    description: null
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Upload team image from the form.
    */
    onChangeFileUpload(event) {
      this.image = event.target.files[0];
    },

    /* 
      Call TeamService class to update certain data on team.
    */
    updateTeam(data) {
      const formData = new FormData();

      if (this.name != data.name) {
        formData.append("name", data.name);
      }
      
      if (this.image != null) {
        formData.append("image", this.image);
      }

      formData.append("description", data.description);

      TeamService.updateTeam(this.id, formData).then(() => {
        location.reload();
      });
    },
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Check if user is authenticated.
  */
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  }
};
</script>
